import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Procard component for displaying a PRO card with a lock icon.
 * @returns - A React element representing the Procard component.
 */
export default function Procard(): ReactElement {
  return (
    <NavLink
      to="/pricing"
      className="flex bg-pink rounded border-pink border px-2 text-white py-0.5 items-center"
    >
      <span className="material-icons-outlined text-xs leading-3 pr-1">lock</span>
      <p className="text-xs font-semibold">PRO</p>
    </NavLink>
  );
}
